<script>
import Layout from "@layouts/form";
import ProjetoTipo from "@forms/ProjetoTipo";

export default {
  page: {
    title: "Detalhes | Tipo de Projeto"
  },
  components: { Layout, ProjetoTipo },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Tipo de Projeto",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Tipo de Projeto",
          href: "/ProjetoTipo"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ProjetoTipo :editable="editable"></ProjetoTipo>
    </div>
  </Layout>
</template>
